import React from 'react'
import { Platform, View } from 'react-native'
import { LinkPreview } from '../link-preview'
import { Text } from '../text'

const REGEX = new RegExp(
  /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/g, // eslint-disable-line
)

export interface TextPostProps {
  content: string
  truncate?: boolean
  noPadding?: boolean
}

/**
 * Text Post component
 */
export const TextPost = ({ content, truncate, noPadding }: TextPostProps) => {
  return (
    <View style={{ flexDirection: 'column' }}>
      {Platform.OS !== 'web' ? (
        <>
          <Text
            style={{ paddingHorizontal: noPadding ? 0 : 20, marginBottom: 10 }}
            numberOfLines={truncate ? 4 : undefined}
            text={content}
          />
          <LinkPreview
            // @ts-ignore
            text={content}
          />
        </>
      ) : (
        <Text
          style={{ paddingHorizontal: 14 }}
          numberOfLines={truncate ? 4 : undefined}
          text={content}
        />
      )}
    </View>
  )
}
